import React from "react";

const Table = ({
  data,
  columns,
  selectedItems,
  handleSelectItem,
  handleBulkSelect,
  requestSort,
  sortField,
  sortDirection,
  onRowClick,
  isLoading,
  formatters = {},
}) => {
  return (
    <table className="table">
      <thead>
        <tr>
          <th className="checkbox-column">
            <input
              type="checkbox"
              onChange={() => handleBulkSelect(data)}
              checked={selectedItems.length === data.length}
              disabled={isLoading}
            />
          </th>
          {columns.map((column) => (
            <th
              key={column.key}
              onClick={() => (column.sortable ? requestSort(column.key) : null)}
              className={column.sortable ? "sortable-header" : ""}
            >
              {column.label}
              {sortField === column.key && column.sortable && (
                <span
                  className={`arrow ${sortDirection === "asc" ? "up" : "down"}`}
                ></span>
              )}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {isLoading ? (
          <tr key="loading">
            <td colSpan={columns.length + 1}>Loading...</td>
          </tr>
        ) : data && data.length > 0 ? (
          data.map((item) => (
            <tr key={item.id || item.uid} onClick={() => onRowClick(item)}>
              <td
                className="checkbox-column"
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => handleSelectItem(item)}
                  checked={selectedItems.some(
                    (selected) =>
                      (selected.id || selected.uid) === (item.id || item.uid)
                  )}
                />
              </td>
              {columns.map((column) => (
                <td key={`${item.id || item.uid}-${column.key}`}>
                  {formatters[column.key]
                    ? formatters[column.key](item[column.key])
                    : item[column.key]}
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr key="no-data">
            <td colSpan={columns.length + 1}>No data available</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default Table;
